import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full  py-4 bg-white text-center">
      <h1 className="text-[#af61dd]">All Rights Reserved Kaizen Global 2025</h1>
      <Link
        to={"/terms-and-services"}
        className="text-[#af61dd] underline mt-2"
      >
        Terms and Services
      </Link>
      <Link
        style={{ marginLeft: 12 }}
        to={"/privacy-policy"}
        className="text-[#af61dd] underline mt-2"
      >
        Privacy Policy
      </Link>
    </footer>
  );
}
